import { Ng2StateDeclaration } from "@uirouter/angular";
import { Error500PageComponent } from "./error.500.component";

export const error500StateDeclaration: Ng2StateDeclaration = {
  name: 'error.500',
  url: "/500",
  component: Error500PageComponent
}
